// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"ExerciseInfo_topContainer__3rXpF","content":"ExerciseInfo_content__iWc74","name":"ExerciseInfo_name__21tcS"};